import { useIsLightspeedEnabled } from 'restaurantAdmin/hooks/useIsLightspeedEnabled';
import type { LightspeedOrder } from '@shared/types/reservations';
import { formatMoney } from '@shared/utils/currency';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import receiptStyles from '../reservationGuestSheetReceipt/ReservationGuestSheetReceipt.scss';
import styles from './OrderDetails.scss';

export interface OrderDetailsProps {
  order: LightspeedOrder | null | undefined;
  className?: string;
}

export const OrderDetails = ({ order, className }: OrderDetailsProps) => {
  const isLightspeedEnabled = useIsLightspeedEnabled();

  if (!isLightspeedEnabled || !order) {
    return null;
  }

  return (
    <section className={cx(receiptStyles.section, className)}>
      <h3 className={typography.h7_20}>
        <span>Order Details</span>
      </h3>
      {order.items.length === 0 ? (
        <p className={cx(typography.h7, styles.emptyState)}>
          No purchases have been made yet
        </p>
      ) : (
        <dl className={typography.h7}>
          {order.items.map((item) => (
            <div key={item.id}>
              <dt>{`${item.quantity} x ${item.name}`}</dt>
              <dd>{formatMoney(item.total, order.currency)}</dd>
            </div>
          ))}
          {/* Prices before tax, like every other spend figure in the admin. */}
          <div className={typography.h7_20}>
            <dt>
              <strong>Total</strong>
            </dt>
            <dd>
              <strong>{formatMoney(order.subtotal, order.currency)}</strong>
            </dd>
          </div>
        </dl>
      )}
    </section>
  );
};
